import type { PropsWithChildren } from "react";
import { Dropdown } from "./Dropdown";
import { Item } from "./Item";
import { Label } from "./Label";
import { Root } from "./Root";
import { Trigger } from "./Trigger";

export const Menu = {
  Root,
  Trigger,
  Dropdown,
  Divider: () => <hr />,
  Label,
  Item,
  Button: ({ children }: PropsWithChildren) => children,
};
